// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"writing-module--wrapper--5HGT6"};